import type { KeypointType } from '@witmetrics/utils';
import { searchByKey } from '@witmetrics/utils/arrays';

export const classes = {
  wrapper: 'pl-8 mb-8',
  card: 'w-full flex flex-col px-4 pt-3 pb-2 mt-2 mb-2',
  settingsWrapper: 'pt-3 pb-4',
  dateInput: 'mt-4 w-full',
  buttonsWrapper: 'flex justify-between pb-1 pt-8',
  button: 'py-1',
  cancel: 'text-grey-6 dark:text-mauve-3',
  saveWrapper: 'flex items-center',
};

export function buildKeypointTypeOptions(keypointTypes: KeypointType[]) {
  return keypointTypes.map((keypointType) => ({
    label: keypointType.name,
    value: keypointType.id,
  }));
}

export function searchKeypointTypes(
  keypointTypes: KeypointType[],
  search: string
) {
  const options = buildKeypointTypeOptions(keypointTypes);
  return searchByKey(options, 'label', search);
}
